/**
 * Hằng số dùng riêng cho danh mục ngân hàng/kho bạc
 */
export default {
  /**
   * Mã ngân hàng ảo mặc định — đại diện cho "Tiền mặt tại quỹ"
   * Không cho phép sửa, xóa, ngừng theo dõi
   */
  DefaultVirtualBankCode: '00000000',
};
